<template>
  <el-container id="app" direction="vertical" class="w-height">
    <Menu
      :is-open-menu.sync="isOpenMenu"
      @trigger-menu="handlerTriggerMenu"
      @open-modal-login="openModalLogin"
      @open-modal-trial="openModalTrial"
    />
    <Header @trigger-menu="handlerTriggerMenu" />
    <router-view class="view" :class="{ 'view--payment': isPayment }" />
    <Footer v-if="isVisibleFooter" />
    <!-- TODO Сделать потом проверку на авторизацию, так как формы только на вход-->
    <ModalLogin :visible.sync="isModalLogin" />
    <ModalTrialLesson :visible.sync="isModalTrial" />
  </el-container>
</template>

<script>
import Menu from '@/components/Layout/Menu'
import Footer from '@/components/Layout/Footer'
import Header from '@/components/Layout/Header'
import ModalLogin from '@/components/Auth/ModalLogin'
import ModalTrialLesson from '@/components/Auth/ModalTrialLesson'

export default {
  components: { ModalTrialLesson, ModalLogin, Header, Footer, Menu },
  data: () => ({
    isOpenMenu: false,
    isModalLogin: false,
    isModalTrial: false
  }),

  computed: {
    isVisibleFooter() {
      return ['index', 'register-step-one', 'register-step-two'].includes(this.$route.name)
    },

    isPayment() {
      return this.$route.name === 'payment'
    }
  },

  methods: {
    handlerTriggerMenu() {
      this.isOpenMenu = !this.isOpenMenu
    },

    openModalTrial() {
      this.isModalTrial = true
      this.isOpenMenu = false
    },

    openModalLogin() {
      this.isModalLogin = true
      this.isOpenMenu = false
    }
  }
}
</script>

<style lang="scss">
#app {
  width: 100vw;
  padding-left: 120px;
  background: $whisper;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  margin: 0;
  display: flex;

  @include md-and-down {
    padding-left: 0;
  }

  .view {
    width: 100%;
    padding: 36px 48px 24px;
    flex: 1;
    height: 100%;

    &--payment {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 123;
      min-height: 100%;
      height: auto;
    }

    @include md-and-down {
      padding: 16px 16px 24px;
    }
  }
}
</style>
